import { Box, Button, Grid } from '@material-ui/core';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { TransitionProps } from '@mui/material/transitions';
import axios from "axios";
import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { API_URL, AUTHORITY_NO_LIST } from "../../Const";
import GenericTemplate from "../templates/GenericTemplate";
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';



/* ダイアログ関連*/
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/*ダイアログ関連*/


const ConstructionCreat: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()

  /*スピナー処理*/
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  /*スピナー処理*/

  /*ダイアログ処理*/
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  /*ダイアログ処理*/


  /*id取得*/
  const { state } = useLocation();
  const check_id = (state as any)?.check_id;
  const conid = (state as any)?.conid;

  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')
  //console.log(jsonlist.token.IdToken)

  const [posts, setPosts] = useState<any[]>([])
  useEffect(() => {
    openLoading()
    axios.post(API_URL.CHECKLIST_GET,
      {
        "company_id": jsonlist.user.company_id,
        "checklist_group_id": check_id
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const persons = res.data.data;
        console.log(persons)
        setPosts(persons)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })
  }, []);
  const checklist_name = (posts as any)?.checklist_name;
  const checklist_memo = (posts as any)?.checklist_memo;
  const created_by = (posts as any)?.created_by;
  const updated_by = (posts as any)?.updated_by;
  const checklist_group_id = (posts as any)?.checklist_group_id;

  const [lists, setList] = useState<any[]>([])
  useEffect(() => {
    openLoading()
    axios.post(API_URL.CHECKLIST_GET,
      {
        "company_id": jsonlist.user.company_id,
        "checklist_group_id": check_id
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const list = res.data.data.list;
        //console.log(list)
        setList(list)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })
  }, []);


  const DelCheckSubmit = (e: any) => {
    handleClickOpen();
  }

  const history = useHistory();
  const clickSubmit = (e: any) => {

    /*スピナー*/
    if (!loading) {
      setSuccess(false);
      setLoading(true);
    }
    /*スピナー*/

    // POST処理　削除

    openLoading()
    axios.post(API_URL.CHECKLIST_DELETE,
      {
        "company_id": jsonlist.user.company_id,
        "checklist_group_id": checklist_group_id
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const del = res.data.data;
        setSuccess(true);
        setLoading(false);
        console.log('削除成功')
        closeLoading()
        history.push({ pathname: "/Checklist", state: { conid: conid } });
      })
      .catch(error => {
        setSuccess(true);
        setLoading(false);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })

  }


  return (

    <GenericTemplate title="チェックリスト名">

      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>{"このデータを削除しますか？"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ m: 1, position: 'relative' }}>
                <Button
                  style={{ color: "#fff", backgroundColor: "#1e88e5" }}
                  onClick={handleClose}
                >キャンセル</Button>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ m: 1, position: 'relative' }}>
                {loading
                  ?
                  <Button
                    style={{ width: "100px" }}
                    variant="contained"
                    disabled={loading}
                    onClick={clickSubmit}
                  >削除する
                  </Button>
                  :
                  <Button
                    style={{ color: "#fff", backgroundColor: "red", width: "100px" }}
                    disabled={loading}
                    onClick={clickSubmit}
                  >削除する
                  </Button>
                }
                {loading && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: green[500],
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-12px',
                      marginLeft: '-12px',
                    }}
                  />
                )}
              </Box>
            </Box>
          </DialogActions>
        </Dialog>
      </div>


      <Grid container spacing={0}>
        <Grid item xs={2}>
        </Grid>
        <Grid item xs={2}>
        </Grid>
        <Grid item xs={3}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ m: 1, position: 'relative' }}>
              {jsonlist.user.authority_code !== AUTHORITY_NO_LIST.USER.toString() ?
                <Button
                  style={{ color: "#fff", backgroundColor: "red" }}
                  variant="contained"
                  onClick={DelCheckSubmit}
                >
                  このチェックリストを削除
                </Button>
                : <></>
              }
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid container spacing={0} justifyContent="center">
          <Grid item xs={2} className="detail-title">チェックリスト名</Grid>
          <Grid item xs={10}>
            <TextField
              inputProps={{ readOnly: true }}
              id="outlined-basic"
              variant="standard"
              className="InsText3"
              multiline={true}
              value={checklist_name}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid container spacing={0} justifyContent="center">
          <Grid item xs={2} className="detail-title">概要</Grid>
          <Grid item xs={10}>
            <TextField
              inputProps={{ readOnly: true }}
              id="outlined-basic"
              variant="standard"
              className="InsText3"
              multiline={true}
              rows={2}
              value={checklist_memo}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid container spacing={0}>
          <Grid item xs={2} className="detail-title">作成者*</Grid>
          <Grid item xs={10}><TextField inputProps={{ readOnly: true }} id="standard-basic" variant="standard" value={created_by} /></Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid container spacing={0}>
          <Grid item xs={2} className="detail-title">最終更新者*</Grid>
          <Grid item xs={10}><TextField inputProps={{ readOnly: true }} id="standard-basic" variant="standard" value={updated_by} /></Grid>
        </Grid>
      </Stack>
      <Stack spacing={3} margin={2}></Stack>

      <div className="textBoxCheck">
        {lists.map((row, index) => (
          <Grid container spacing={0} key={index}>
            <TextField style={{ width: 500, margin: 10 }} inputProps={{ readOnly: true }} id="standard-basic" variant="standard" value={row.item_name} />
          </Grid>
        ))}
      </div>

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={0} margin={0}>
        <Grid container spacing={0}>
          <Grid item xs={2}>
            <Button
              className="btnlink"
              color="primary"
              variant="contained"
              size="large"
              component={Link}
              to="/Checklist"
            >
              戻る
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              className="btnlink"
              style={{ color: "#fff", backgroundColor: "#FFA500" }}
              variant="contained"
              size="large"
              component={Link}
              to={{ pathname: "/CheckEdit", state: { check_id: check_id, lists: lists } }}
            >
              チェックリスト編集
            </Button>
          </Grid>
        </Grid>
      </Stack>




    </GenericTemplate>
  );
};

export default ConstructionCreat;